import { theme as defaultTheme } from './themes/default/classes';
import { theme as cleanTheme } from './themes/clean/classes';
import { theme as rawHtmlTheme } from './themes/rawHtml/classes';
import { htmlImportMap } from './conversion';
import { type LexicalEditorProfile, type ResolvedLexicalEditorProfile } from './profileTypes';
import { constructRawHtmlExportMap } from './conversion/rawHtmlExportMap';
import { RAW_HTML_TABLE_NODES } from './nodes/rawHtmlTable';
import { DEFAULT_NODES } from './defaultNodes';

export function createDefaultProfile(): ResolvedLexicalEditorProfile
{
    return {
        theme: defaultTheme,
        nodes: DEFAULT_NODES,
        importMap: htmlImportMap,
        exportTheme: cleanTheme,
    };
}

export function createRawHtmlProfile(): ResolvedLexicalEditorProfile
{
    return {
        theme: rawHtmlTheme,
        nodes: RAW_HTML_TABLE_NODES,
        importMap: htmlImportMap,
        exportMap: constructRawHtmlExportMap(),
        exportTheme: cleanTheme,
        containerClassName: 'editor-container--raw-html',
        features:
        {
            rawHtmlTableStyle: true,
        }
    };
}

export function resolveLexicalEditorProfile(profile?: LexicalEditorProfile): ResolvedLexicalEditorProfile
{
    switch (profile?.kind) {
        case 'raw-html':
            return createRawHtmlProfile();
        default:
            return createDefaultProfile();
    }
}